import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { colors, SPACE_COZY, SPACE_COMPACT, flex, center, borderColor } from '@/styles';

const LOG_ITEM_PADDING = `${SPACE_COZY}px`;

// NOTE: This is needed so that vertical overflow works in the dialog. It's not
// pretty as we're styling elements of an AK component via the `testId` prop.
// We are probably at a point where we have exhausted the use of the AKInlineDialog
// component for these kind of context popups, perhaps a real modal instead of
// hacking the intent of the component out of the box.
// absolute important forces the dialog to appear next to the relevant element as
// opposed to the viewport.
export const root = css`
  [data-testid='slo-graph-error-log'] {
    position: absolute !important;
    overflow-y: auto;
  }
`;

export const item = css`
  &:not(:last-child) {
    border-bottom: 1px solid ${borderColor};
    padding-bottom: ${LOG_ITEM_PADDING};
  }

  &:not(:first-of-type) {
    padding-top: ${LOG_ITEM_PADDING};
  }
`;

export const timestamp = css`
  color: ${token('color.text.subtlest', colors.N90)};
  display: block;
  font-size: 0.9em;
  margin-top: ${SPACE_COMPACT}px;
`;

export const logItemStyles = [
  flex,
  center,
  css`
    flex-shrink: 0;
    padding-right: 10px;
  `,
];
